<template>
<div id="card-row" class="container">
    <div class="row">
        <div class="col-12 d-flex justify-content-start pr-0">
            <div class="card card-40 row col-11 align-items-center justify-content-between">
                <div class="d-flex flex-column justify-content-center ml-2">
                    <h4 :class="`bold c-${getPrimaryColor}four mb-0`">
                        Cadastrar {{ renderTitle }}
                    </h4>
                    <p class="c-ndarkfour">
                        Vincule os CNPJs {{renderSubtitle}} do grupo <span class="bold">{{ $store.state.group.group.name | formatName }}</span>
                    </p>
                </div>
                <div class="d-flex align-items-center justify-content-center mr-2">
                    <Button @click="goBackButton" type="outline" :color="getPrimaryColor">
                         Voltar
                    </Button>
                    <Button @click="nextStep" class="ml-3" :color="getPrimaryColor">
                        Continuar
                    </Button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    data() {
        return {
            company: this.$route.path.includes('buyer') ? 'buyer' : 'provider'
        }
    },
    methods: {
        nextStep() {
            if (this.company === 'buyer') {
                this.$router.push(`/group/${this.$route.params.groupId}/provider`)
            } else {
                this.$router.push(`/group/${this.$route.params.groupId}/setting`)
            }
        },
        goBackButton() {
            if (this.company === 'buyer') {
                this.$router.push(`/group`)
            } else {
                this.$router.push(`/group/${this.$route.params.groupId}/buyer`)
            }
        }
    },
    computed: {
        renderTitle() {
            const title = this.company === 'buyer' ? 'filiais' : 'cedentes'
            return title
        },
        renderSubtitle() {
            const subTitle = this.company === 'buyer' ? 'das filiais' : 'dos cedentes'
            return subTitle
        }
    },
}
</script>

<style>
</style>